import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: '12px !important',
}));

const AdjustmentsSubheader: FC = () => {
  return (
    <StyledTypography variant="h6">
      Adjustments to reconcile net income to net cash provided by / (used in)
      operating activities:
    </StyledTypography>
  );
};

export default AdjustmentsSubheader;
